<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <InstallInstructionsForm
        :installInstruction="defaultInstallInstruction"
      />
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from "@/components/layout/PageTitle";
import PageRowWrapper from "@/components/layout/PageRowWrapper";
import InstallInstructionsForm from "@/components/settings/integrador/install-instructions/InstallInstructionsForm";

export default {
  name: "InstallInstructionsAddView",
  components: {
    PageTitle,
    PageRowWrapper,
    InstallInstructionsForm,
  },

  data() {
    return {
      defaultInstallInstruction: {
        id: undefined,
        client: undefined,
        html: `<ul><li><span style="background-color: rgb(255, 156, 0);"><font color="#000000"><b>Aba GLOBAL</b></font></span><ul><li><font color="#000000"><b>ORIGEM:</b> Selecionar a origem cadastrada em&nbsp;<b>app.frotix</b>. Se tiver mais de 1 (uma), perguntar ao usuário a <b>origem/filial</b> dele;</font></li><li><font color="#000000"><b>Pasta XML Origem</b></font><ul><li><font color="#000000">Selecionar</font></li><li><font color="#000000">Disco Local (C:)</font></li><li><font color="#000000">Selecionar/Criar pasta "Integrador Frotix"</font></li><li><font color="#000000">Selecionar/Criar pasta "Origem"</font></li></ul></li><li><font color="#000000"><span style="font-weight: bolder;">Pasta XML Destino</span></font><ul><li><font color="#000000">Selecionar</font></li><li><font color="#000000">Disco Local (C:)</font></li><li><font color="#000000">Selecionar/Criar pasta "Integrador Frotix"</font></li><li><font color="#000000">Selecionar/Criar pasta "Destino"</font></li></ul></li><li><font color="#000000"><span style="font-weight: bolder;">Pasta XML Enviados</span></font><ul><li><font color="#000000">Selecionar</font></li><li><font color="#000000">Disco Local (C:)</font></li><li><font color="#000000">Selecionar/Criar pasta "Integrador Frotix"</font></li><li><font color="#000000">Selecionar/Criar pasta "Enviados"</font></li></ul></li></ul></li></ul><p style="margin-left: 25px;"><ul></ul></p><p style="margin-left: 25px;"><font color="#000000">CONTINUE AQUI ...</font></p>`,
      },
    };
  },
};
</script>
